import { render, staticRenderFns } from "./SearchDinamicField.vue?vue&type=template&id=68597118&"
import script from "./SearchDinamicField.vue?vue&type=script&lang=js&"
export * from "./SearchDinamicField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemActionText } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItemActionText})
